import moment from "moment";

const escapeCsvValue = (value) => {
  const stringValue = String(value ?? "");
  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

const toCsvRow = (cells) => cells.join(",");

// Excel auto-parses time-like strings as its own date/time serial values,
// corrupting the precision we want. Wrapping as ="..." forces literal text.
const asText = (value) => `="${String(value ?? "").replace(/"/g, '""')}"`;

export const generateNstVitalsCsv = ({
  patientName,
  patientIdentifierLabel,
  patientIdentifierValue,
  presentation,
  age,
  numberOfFetus,
  gestationalAge,
  deviceUsed,
  sessionTime,
  totalMonitoringTime,
  columns,
  rows,
}) => {
  const lines = [
    toCsvRow([escapeCsvValue("Name"), escapeCsvValue(patientName || "--")]),
    toCsvRow([escapeCsvValue(patientIdentifierLabel), escapeCsvValue(patientIdentifierValue || "--")]),
    toCsvRow([escapeCsvValue("Presentation"), escapeCsvValue(presentation || "--")]),
    toCsvRow([escapeCsvValue("Age"), escapeCsvValue(age || "--")]),
    toCsvRow([escapeCsvValue("Number of fetus"), escapeCsvValue(numberOfFetus || "--")]),
    toCsvRow([escapeCsvValue("Gestational Age"), escapeCsvValue(gestationalAge || "--")]),
    toCsvRow([escapeCsvValue("Device Used"), escapeCsvValue(deviceUsed || "--")]),
    toCsvRow([escapeCsvValue("Time"), asText(sessionTime || "--")]),
    toCsvRow([escapeCsvValue("Total Monitoring Time"), escapeCsvValue(totalMonitoringTime || "--")]),
    "",
    toCsvRow([
      escapeCsvValue("Time"),
      ...columns.map((column) => escapeCsvValue(column.label)),
      escapeCsvValue("FM"),
    ]),
    ...rows.map((row) =>
      toCsvRow([
        asText(moment(row.time * 1000).format("hh:mm:ss A")),
        ...columns.map((column) => escapeCsvValue(row[column.key] ?? "—")),
        escapeCsvValue(row.fm),
      ]),
    ),
  ];

  const csvContent = "﻿" + lines.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const safeName = (patientName || "patient").replace(/[^a-z0-9]+/gi, "_");
  const link = document.createElement("a");
  link.href = url;
  link.download = `Vitals_${safeName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
